<!--<template>-->
    <!--<div class='menu-wrapper'>-->

        <!--&lt;!&ndash;<template v-for="(item,i) in routes">&ndash;&gt;-->
        <!--&lt;!&ndash;<template v-if="item.children">&ndash;&gt;-->
        <!--&lt;!&ndash;<el-submenu :index="item.path+'/'+item.children[0].path">&ndash;&gt;-->
        <!--&lt;!&ndash;<template slot="title"><i :class="item.icon ? item.icon : ''"></i>{{item.name}}</template>&ndash;&gt;-->


        <!--&lt;!&ndash;<template v-for="(subItem,i1) in item.children">&ndash;&gt;-->
        <!--&lt;!&ndash;<template v-if="subItem.children">&ndash;&gt;-->
        <!--&lt;!&ndash;<el-submenu :index="item.path + '/' + subItem.path + '/' + subItem.children[0].path">&ndash;&gt;-->
        <!--&lt;!&ndash;<template slot="title"><i :class="subItem.icon ? subItem.icon : ''"></i>{{subItem.name}}</template>&ndash;&gt;-->

        <!--&lt;!&ndash;<template v-if="subItem.children">&ndash;&gt;-->
        <!--&lt;!&ndash;<el-menu-item v-for="(subItemItem,i2) in subItem.subs" :key="i2" :index="item.path + '/' + subItem.path + '/' + subItemItem.path">&ndash;&gt;-->
        <!--&lt;!&ndash;<template slot="title"><i :class="subItemItem.icon ? subItemItem.icon : ''"></i>{{subItemItem.name}}</template>&ndash;&gt;-->
        <!--&lt;!&ndash;</el-menu-item>&ndash;&gt;-->
        <!--&lt;!&ndash;</template>&ndash;&gt;-->

        <!--&lt;!&ndash;</el-submenu>&ndash;&gt;-->
        <!--&lt;!&ndash;</template>&ndash;&gt;-->

        <!--&lt;!&ndash;<template v-else>&ndash;&gt;-->
        <!--&lt;!&ndash;<el-menu-item :index="item.path + '/' + subItem.path">&ndash;&gt;-->
        <!--&lt;!&ndash;<i :class="subItem.icon ? subItem.icon : ''"></i>{{ subItem.name }}&ndash;&gt;-->
        <!--&lt;!&ndash;</el-menu-item>&ndash;&gt;-->
        <!--&lt;!&ndash;</template>&ndash;&gt;-->
        <!--&lt;!&ndash;</template>&ndash;&gt;-->

        <!--&lt;!&ndash;</el-submenu>&ndash;&gt;-->
        <!--&lt;!&ndash;</template>&ndash;&gt;-->
        <!--&lt;!&ndash;<template v-else>&ndash;&gt;-->
        <!--&lt;!&ndash;<el-menu-item :index="item.path">&ndash;&gt;-->
        <!--&lt;!&ndash;<template slot="title"><i :class="item.icon ? item.icon : ''"></i>{{item.name}}</template>&ndash;&gt;-->
        <!--&lt;!&ndash;</el-menu-item>&ndash;&gt;-->
        <!--&lt;!&ndash;</template>&ndash;&gt;-->
        <!--&lt;!&ndash;</template>&ndash;&gt;-->

        <!--<template v-for="(item,i) in routes">-->
            <!--<template v-if="item.children">-->
                <!--<el-submenu :index="item.path+'/'+item.children[0].path">-->
                    <!--<template slot="title"><i :class="item.icon ? item.icon : ''"></i>{{item.path}}-{{item.name}}</template>-->

                    <!--<template v-for="subChild in item.children">-->
                        <!--<sidebar-item :routes='[subChild]'></sidebar-item>-->
                    <!--</template>-->

                <!--</el-submenu>-->
            <!--</template>-->
            <!--<template v-else>-->
                <!--<el-menu-item :index="item.path">-->
                    <!--<template slot="title"><i :class="item.icon ? item.icon : ''"></i>{{item.path}}-{{item.name}}</template>-->
                <!--</el-menu-item>-->
            <!--</template>-->
        <!--</template>-->


    <!--</div>-->
<!--</template>-->

<!--<script>-->
    <!--export default {-->
        <!--name: 'SidebarItem',-->
        <!--props: {-->
            <!--routes: {-->
                <!--type: Array-->
            <!--}-->
        <!--}-->
    <!--}-->
<!--</script>-->

<template>
    <div v-if="!item.hidden&&item.children">
        <router-link v-if="!item.hidden&&item.children.length===0" :to="item.path">
            <el-menu-item class="submenu-title-noDropdown" :index="item.path">
                <icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg>
                <span slot="title">
                    <el-badge is-dot class="item" :hidden="!(item.title == '租户管理' && customer == true) && !(item.title == '访客管理' && visitor === true) && !(item.title == '报事报修' && repari === true) && !(item.title == '预约管理' && yuyue === true)">
                        <span>{{item.title}}</span>
                    </el-badge>
                </span>
            </el-menu-item>
        </router-link>

        <el-submenu class="nest-menu" :index="item.path" v-else-if="item.children.length!==0&&!item.hidden">
            <template slot="title">
                <icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg>
                <span v-if='item.title' slot="title">
                    <el-badge is-dot class="item" :hidden="!(item.title == '租户管理' && customer == true) && !(item.title == '访客管理' && visitor === true) && !(item.title == '报事报修' && repari === true) && !(item.title == '预约管理' && yuyue === true)">
                        <span>{{item.title}}</span>
                    </el-badge>
                </span>
            </template>
            <template v-for="child in item.children" v-if='!child.hidden'>

                <sidebar-item :key="child.path" v-if='child.children&&child.children.length>0' :item='child'> </sidebar-item>

                <router-link :key="child.path" v-else :to="child.path">
                    <el-menu-item :index="child.path">
                        <icon-svg v-if='child.icon' :icon-class="child.icon"></icon-svg>
                        <span slot="title">
                            <el-badge is-dot class="item" :hidden="!(child.title == '客户管理' && customer === true) && !(child.title == '访客管理' && visitor === true) && !(child.title == '报事报修' && repari === true) && !(child.title == '预约管理' && yuyue === true)">
                                <span>{{child.title}}</span>
                            </el-badge>
                        </span>
                    </el-menu-item>
                </router-link>

            </template>

        </el-submenu>
    </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../utils/auth";
export default {
    name: "SidebarItem",
    props: {
        item: {}
    },
    methods: {
        // 查找子节点是否有可显示的节点
        hasFilterChildrenHidden(children) {
            const showingChildren = children.filter(item => {
                return !item.hidden;
            });
            return showingChildren.length === 1;
        }
    },
    created() {
    },
    computed: {
        visitor () {
            return this.$store.state.AuditvisitorsModule.visitor;
        },
        customer () {
            return this.$store.state.AuditvisitorsModule.customer;
        },
        repari () {
            return this.$store.state.AuditvisitorsModule.repari;
        },
        yuyue () {
            return this.$store.state.AuditvisitorsModule.yuyue;
        }
    }
};
</script>

<style>
.el-scrollbar__view .el-menu .item {
    height: 30px;
    line-height: 26px;
}
.el-scrollbar__view .el-menu .item .el-badge__content {
    right: 0px;
}
</style>
